export default "__VITE_ASSET__BpQGbaha__"